import { GGTheme } from 'themes/types';

export const config: GGTheme = {
  token: 'classic-theme',
  name: 'Classic',
  palette: {
    name: 'classic-palette',
    token: 'classic-palette',
    accentPrimary: {
      end: {
        x: 1,
        y: 1,
      },
      start: {
        x: 0,
        y: 0,
      },
      colors: ['#5966F8', 'red'],
      locations: [0, 1],
    },
    accentSecondary: '#5A5E6D',
    accentTertiary: '#727587',
    textPrimary: '#FFFFFF',
    textSecondary: '#000000',
    textTertiary: '#9295A5',
    textActive: '#FFFFFF',
    textError: '#ff5454', // --text-error
    bgPrimary: '#2C2E32',
    bgSecondary: '#1B1D21',
    bgTertiary: '#21242A',
    bgActive: '#21242A',
    bgError: '#21242A',
  },
  fonts: {
    token: 'classic-fonts',
    name: 'Classic Fonts',
    headings: [],
    body: [],
  },
};
